import { render, staticRenderFns } from "./FacebookTemplateModal.vue?vue&type=template&id=fab2e834"
import script from "./FacebookTemplateModal.vue?vue&type=script&lang=js"
export * from "./FacebookTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports